$(function() {
    const treeElement = $('#tree');
    const jsonTree = $('#tree_json').val();
    dataTree = JSON.parse(jsonTree);

    treeElement.jstree({
        'core': {
            'check_callback': false,
            'themes': {
                'variant': 'large',
            },
            'data': dataTree,
        },
        'plugins': [
            'dnd',
        ],
    }).on('loaded.jstree', function () {
        treeElement.jstree().deselect_all(true);
        treeElement.jstree('open_all');
    }).on('select_node.jstree', function (e, data) {
        if (
            typeof data.node !== 'undefined' &&
            typeof data.node.data !== 'undefined' &&
            data.node.data.type == 4
        ) {
            var editionId = $('#edition_id').val();
            location.href = '/edicao/' + editionId + '?act=' + data.node.id;
        }
    });
});
